module.exports = __webpack_public_path__ + "static/img/about1.cc7f27f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about1.jpg
// module id = ypQK
// module chunks = 0